// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3EEcm","addWidgetButton":"Header_addWidgetButton__2tyLy","dashboardTabs":"Header_dashboardTabs__3DDA5","active":"Header_active__1BD0B"};